import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const handleAccess = () => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate(`/nomination/profile`);
    } else {
      navigate("/nomination/login");
    }
  };

  useEffect(() => {
    handleAccess();
  });
};

export default Home;
